// @ts-check

export default {
    /**
     *
     * @param {HTMLInputElement | HTMLTextAreaElement} el
     */
    mounted(el) {
        el.style.height = `${el.scrollHeight}px`;
        el.addEventListener("input", () => {
            el.style.height = "1px";
            el.style.height = `${el.scrollHeight}px`;
        });
    },
};
